import { render, staticRenderFns } from "./WorkSubmenuGroup.vue?vue&type=template&id=06c1ffc6&scoped=true"
import script from "./WorkSubmenuGroup.vue?vue&type=script&lang=js"
export * from "./WorkSubmenuGroup.vue?vue&type=script&lang=js"
import style0 from "./WorkSubmenuGroup.vue?vue&type=style&index=0&id=06c1ffc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1ffc6",
  null
  
)

export default component.exports